// 27 Oct (Glow Wand launch): opt-in add-on tile in the buy box (snippets/glow-addon.liquid writes #glowAddon + #GlowAddonData).
// Never pre-ticked. glow.js asks window.GlowAddon for extra cart lines when the shopper adds the main item, and for the
// extra price to show on the button. The add-on price itself is an automatic discount in Shopify (see upsell/ADMIN-SETUP.md).
(function () {
  const el = document.getElementById('glowAddon'), dataEl = document.getElementById('GlowAddonData');
  if (!el || !dataEl) return;
  const A = JSON.parse(dataEl.textContent);
  const R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const money = c => (A.moneyFormat || '£{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, (c / 100).toFixed(2)).replace(/<[^>]*>/g, '');
  const esc = t => String(t == null ? '' : t).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const preProp = A.pre ? String(A.pre).replace(/^Pre-order:\s*/i, '') : '';
  let on = false, inCart = false;

  el.innerHTML = `<label class="g-addon__row">
      <input type="checkbox" class="g-addon__cb" id="glowAddonCb">
      <span class="g-addon__box" aria-hidden="true"><svg viewBox="0 0 24 24" width="14" height="14"><path d="M5 12.5l4.2 4.2L19 7" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
      ${A.img ? `<img class="g-addon__img" src="${A.img}" alt="" width="52" height="52" loading="lazy">` : ''}
      <span class="g-addon__txt"><b class="g-addon__t">${esc(A.title)}</b><span class="g-addon__l">${esc(A.line)} · ${money(A.price)} on its own</span>${A.pre ? `<span class="g-addon__pre">${esc(A.pre)}</span>` : ''}<span class="g-addon__in" hidden>✓ ${esc(A.name)} is in your cart</span></span>
      <span class="g-addon__price"><b>+${money(A.addon)}</b></span>
    </label>`;
  el.hidden = false;
  const cb = el.querySelector('.g-addon__cb');
  cb.setAttribute('aria-label', `${A.title}: ${A.name} for ${money(A.addon)} (${money(A.price)} on its own)`);

  function sync() {
    cb.checked = on && !inCart;
    cb.disabled = inCart;
    el.classList.toggle('is-on', on && !inCart);
    el.classList.toggle('is-in', inCart);
    el.querySelector('.g-addon__in').hidden = !inCart;
    el.querySelector('.g-addon__price').hidden = inCart;
    document.dispatchEvent(new CustomEvent('glow:addon'));
  }
  cb.addEventListener('change', () => { on = cb.checked; sync(); });

  // a wand already in the cart: show "in your cart" instead of offering a second one at the add-on price
  async function checkCart() {
    try {
      const c = await (await fetch(R + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      const was = inCart;
      inCart = (c.items || []).some(i => i.handle === A.handle);
      if (was !== inCart || inCart) { if (inCart) on = false; sync(); }
    } catch (e) {}
  }
  checkCart();
  // re-check when the cart drawer closes (the shopper may have added or removed the wand there)
  const drawer = document.getElementById('GlowCart');
  if (drawer && 'MutationObserver' in window) new MutationObserver(() => { if (drawer.hidden) checkCart(); }).observe(drawer, { attributes: true, attributeFilter: ['hidden'] });

  window.GlowAddon = {
    // extra /cart/add.js lines for the main add-to-cart call
    items: () => (on && !inCart ? [{ id: A.variantId, quantity: 1, properties: preProp ? { 'Pre-order': preProp } : {} }] : []),
    // pence to add to the price shown on the buy button and sticky bar
    extra: () => (on && !inCart ? A.addon : 0),
    name: A.name,
    // called by glow.js after a successful add
    added: () => { if (on) { on = false; inCart = true; sync(); } },
  };
})();
